import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=0530bdbf&scoped=true&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"
import style0 from "./menus.vue?vue&type=style&index=0&id=0530bdbf&lang=scss&scoped=true&"
import style1 from "./menus.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530bdbf",
  null
  
)

component.options.__file = "menus.vue"
export default component.exports